module.exports = __webpack_public_path__ + "img/icon-burguer-outlined.cf1f8b69.svg";